import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractLloydsRiskCode from "../LloydsRiskCode";

class LloydsRiskCode extends AbstractLloydsRiskCode {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/product-lloyds-risk-codes-ipr';
  }
}

export default LloydsRiskCode;
